import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlusMinusInputComponent } from './plus-minus-input.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule } from '@angular/forms';
import { CurrencyDigitShortcutPipeModule } from 'src/app/pipes/currency-digit-shortcut-pipe.module';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    PlusMinusInputComponent,
  ],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    FormsModule,
    CurrencyDigitShortcutPipeModule,
    TranslateModule,
  ],
  exports: [
    PlusMinusInputComponent,
  ]
})
export class PlusMinusInputModule { }
